import { styled } from '@/styled-system/jsx';
import { Box } from '@zillow/constellation';

export const BannerBox = styled(Box, {
  base: {
    marginBlock: '400',
    maxWidth: '1232px',
    marginInline: 'auto',
    boxSizing: 'content-box',
  },
  variants: {
    isEnterpriseCustomer: {
      true: {
        paddingInline: '600',
      },
      false: {
        paddingInline: { base: '600 !important', lg: 0 },
      },
    },
    canAccessListingQuality: {
      true: {
        paddingInline: '0',
        maxWidth: '100%',
      },
    },
  },
});
